// src/components/Cart/CartPage.jsx
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    selectCartItems,
    selectCartTotals,
    setQty,
    increaseQty,
    decreaseQty,
    removeFromCart,
} from "../../context/MyCartSlice";
import "./cartPage.css";
import { FiMinus, FiPlus, FiTrash2, FiArrowLeft, FiShoppingCart } from "react-icons/fi";


import { Link, useNavigate, useLocation } from "react-router-dom";
const fmt = (x) =>
    Number(x ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function CartPage() {
    const dispatch = useDispatch();
    const items = useSelector(selectCartItems);
    const totals = useSelector(selectCartTotals);
    const navigate = useNavigate();
    console.log("items dans CartPage:", items);

    const location = useLocation();
    // Couleur des pictos "contact" (dans ta maquette: rouge)
    const scrollToProducts = () => {
        // Si déjà sur Home : scroll direct
        if (location.pathname === "/espace") {
            const el = document.getElementById("products-section");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            return;
        }

        // Sinon : navigation vers Home avec un hash
        navigate({ pathname: "/espace", hash: "#products-section" });
    };

    const handleUpdate = () => {
        // ici si tu veux recalculer/sync le panier, fais-le puis navigue
        navigate("/produits");
    };
    return (
        <div className="cart-wrap">
            <h1 className="cart-title">Votre panier</h1>

            <div className="cart-grid">
                <section className="cart-tableCard">
                    <div className="cart-thead">
                        <div>Produits</div>
                        <div className="ta-right hide-sm">Prix</div>
                        <div className="ta-center">Quantité</div>
                        <div className="ta-right">Sous-total</div>
                    </div>

                    {items.length === 0 && <div className="cart-empty">Votre panier est vide.</div>}

                    {items.map((it) => (
                        <div className="cart-row" key={it.CodArt}>
                            <div className="cart-prod">
                                <button
                                    className="iconBtn iconBtn--ghost"
                                    title="Supprimer"
                                    onClick={() => dispatch(removeFromCart(it.CodArt))}
                                >
                                    <FiTrash2 />
                                </button>

                                <div className="cart-thumb">
                                    {it.image ? <img src={it.image} alt={it.LibArt} /> : <div className="thumbPh" />}
                                </div>

                                <div className="cart-prodMeta">
                                    <div className="cart-lib">{it.LibArt}</div>
                                    <div className="cart-sub">
                                        <span className="muted">Réf:</span>&nbsp;{it.CodArt}
                                        {Number.isFinite(it.stockQt) && (
                                            <>
                                                &nbsp;&middot;&nbsp;<span className="muted">Stock:</span>&nbsp;{it.stockQt}
                                            </>
                                        )}
                                        {it.Marque && (
                                            <>
                                                &nbsp;&middot;&nbsp;<span className="muted">Marque:</span>&nbsp;{it.Marque}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="cart-price hide-sm">{fmt(it.PrixTTC)} DT</div>

                            <div className="cart-qty ta-center">
                                <div className="qtyBox">
                                    <button className="qtyBtn" onClick={() => dispatch(decreaseQty(it.CodArt))}>
                                        <FiMinus />
                                    </button>
                                    <input
                                        className="qtyInp"
                                        value={it.qty}
                                        onChange={(e) => {
                                            const n = Math.max(1, parseInt(e.target.value.replace(/\D/g, "") || "1", 10));
                                            dispatch(setQty({ CodArt: it.CodArt, qty: n }));
                                        }}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                    />
                                    <button className="qtyBtn" onClick={() => dispatch(increaseQty(it.CodArt))}>
                                        <FiPlus />
                                    </button>
                                </div>
                            </div>

                            <div className="cart-subtotal ta-right">
                                {fmt((it.PrixTTC || 0) * (it.qty || 0))} DT
                            </div>
                        </div>
                    ))}

                    <div className="cart-actions">
                        <button className="btnOutline" onClick={scrollToProducts}>
                            Mettre à jour le panier
                        </button>
                    </div>
                </section>

                <aside className="cart-summary">
                    <h2 className="sum-title">Total des cartes</h2>

                    <div className="sum-line">
                        <span>Sub-total</span>
                        <b>{fmt(totals.subTTC)} DT</b>
                    </div>

                    <div className="sum-line">
                        <span>NET HT</span>
                        <b>{fmt(totals.totalHT)} DT</b>
                    </div>

                    <div className="sum-line">
                        <span>Livraison</span>
                        <b>Gratuite</b>
                    </div>

                    <div className="sum-line">
                        <span>Remise</span>
                        <b>{fmt(totals.remise)} DT</b>
                    </div>

                    <div className="sum-line">
                        <span>TVA</span>
                        <b>{fmt(totals.totalTVA)} DT</b>
                    </div>

                    <div className="sum-total">
                        <span>Total</span>
                        <b>{fmt(totals.total)} DT</b>
                    </div>

                    <button className="btnPrimary" onClick={() => navigate("/checkout")}>
                        <FiShoppingCart className="btnIcon" />
                        Passer à la validation
                    </button>
                </aside>

            </div>
        </div>
    );
}
